import React, { useState } from 'react';
import ajaxConfig from '../../../util/remote/ajaxConfig';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import BsModal from '../../Common/BsModal';
import TextInput from '../../Common/TextInput';

const NewPaperModal = () => {
  const [paperName, setPaperName] = useState('');
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState(null);
  const {newPaper, setNewPaper} = useConfig();

  const handleSave = async () => {
    if (paperName.length === 0) {
      setNotify(<Notification type='danger' message='Paper name is required' />);
      return;
    }

    setLoading(true);
    const server_response = await ajaxConfig.createSubjectPaper(newPaper.subject.subject_id, paperName);
    setLoading(false);
    if (server_response.status === "OK") {
      newPaper.callback();
      setNotify(<Notification type='success' message={server_response.message} />);
      setPaperName('');

    } else {
      setNotify(<Notification type='danger' message={server_response.message} />);
    }
  };

  const closeModal = () => {
    setNotify(null);
    setNewPaper({ show: false, subject: null });
  };


  return (
    <BsModal
      show={newPaper.show}
      onClose={closeModal}
      title={`New Subject Paper for ${newPaper.subject?.subject}`}
      footer={
        <>
          <button type="button" className="btn btn-secondary" onClick={closeModal}>
            Cancel
          </button>
          <button
            className="btn btn-success"
            disabled={loading || !paperName}
            onClick={handleSave}
          >
            <i className="fa fa-plus-circle mr-1"></i> Create Paper
          </button>
        </>
      }
    >
      <TextInput
        label="Paper Name"
        placeholder="Enter Paper Name"
        leftIcon="fa fa-book"
        value={paperName}
        onChange={e => setPaperName(e.target.value)}
        required
      />
     

      {loading && <div className="mt-3"><i className="fa fa-spinner fa-spin"></i> Saving...</div>}
      {notify}
    </BsModal>
  );
};

export default NewPaperModal;
